import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Button from 'react-bootstrap/Button';

import { login, sendSms } from '../../actions';
// import { useTimer } from '../components/global/timer';
import moment from 'moment';

const Input = ({ handleCodeType, index }) => {
  const [value, setValue] = useState('');

  const handleChange = (e) => {
    if (e.target.value.length <= 1) {
      setValue(e.target.value);
      handleCodeType(e);
    }
  };

  return <input id={index} value={value} onChange={handleChange} type="number" required />;
};

// const initialTime = 30; // seconds

const SyncLoadingModal = ({ visible }) => {
  const [stage, setStage] = useState(0);
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    'Підключаємося до реєстру',
    'Синхронізуємо з лікарнями міста',
    'Завантажуємо медичну картку',
    'Перевіряємо записи на прийом',
    'Майже готово\u2026',
  ];

  useEffect(() => {
    if (!visible) {
      setStage(0);
      setActiveStep(0);
      return;
    }
    const stageTimer = setTimeout(() => setStage(1), 2000);
    const stepTimers = [
      setTimeout(() => setActiveStep(1), 3500),
      setTimeout(() => setActiveStep(2), 7000),
      setTimeout(() => setActiveStep(3), 12000),
      setTimeout(() => setActiveStep(4), 19000),
    ];
    return () => {
      clearTimeout(stageTimer);
      stepTimers.forEach(clearTimeout);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.62)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '32px 28px',
        maxWidth: 340, width: '90%', textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
      }}>
        {stage === 0 ? (
          <>
            <i className="fas fa-spinner fa-spin" style={{ fontSize: 38, color: '#1767c8', marginBottom: 18 }} />
            <p style={{ margin: 0, fontSize: 16, color: '#444' }}>Завантаження...</p>
          </>
        ) : (
          <>
            <i className="fas fa-sync-alt fa-spin" style={{ fontSize: 28, color: '#1767c8', marginBottom: 10 }} />
            <h4 style={{ margin: '0 0 3px', color: '#1767c8', fontWeight: 700, fontSize: 17 }}>
              Синхронізація даних
            </h4>
            <p style={{ margin: '0 0 20px', fontSize: 13, color: '#999' }}>
              з міськими лікарнями
            </p>
            <div style={{ textAlign: 'left' }}>
              {steps.map((step, i) => {
                const isCompleted = i < activeStep;
                const isActive = i === activeStep;
                return (
                  <div key={i} style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    padding: '7px 0', opacity: i > activeStep ? 0.28 : 1,
                    transition: 'opacity 0.5s',
                  }}>
                    <span style={{
                      width: 24, height: 24, borderRadius: '50%', flexShrink: 0,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: isCompleted ? '#28a745' : isActive ? '#1767c8' : '#e9ecef',
                      color: isCompleted || isActive ? '#fff' : '#adb5bd',
                      fontSize: 11, transition: 'background 0.4s',
                    }}>
                      {isCompleted
                        ? <i className="fas fa-check" />
                        : isActive
                        ? <i className="fas fa-spinner fa-spin" />
                        : <span>{i + 1}</span>}
                    </span>
                    <span style={{
                      fontSize: 13,
                      color: isActive ? '#1767c8' : isCompleted ? '#28a745' : '#6c757d',
                      fontWeight: isActive ? 600 : 400,
                      transition: 'color 0.4s',
                    }}>
                      {step}
                    </span>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const Code = ({
  auth: { phone, error },
  onClose,
  sendSms,
  login,
  appointment,
  history,
  denyRedirect,
  connectToBotFn,
  onChangePhone, // Add this prop
}) => {
  const [currentPhone] = useState(phone.phone);
  const [currentSendTime] = useState(phone.send_time);
  const [code, setCode] = useState('');
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(false);

  const codeWrapper = useRef(null);

  useEffect(
    () => () => {
      // resetTimer();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const onSubmit = useCallback(
    (e) => {

      e.preventDefault();

      if (code.length === 4) {
        
        setSubmitButtonDisabled(true);
        setIsAuthLoading(true);

        login({ phone: currentPhone, code }).then((response) => {
          if (response && response.token) {
            if (connectToBotFn) connectToBotFn();
            if (!appointment && !denyRedirect) history.push('/office');
            if (onClose) onClose();
          } else {
            setSubmitButtonDisabled(false);
            setIsAuthLoading(false);
          }
        }).catch(() => {
          setSubmitButtonDisabled(false);
          setIsAuthLoading(false);
        });
      }
    },
    [code, login, currentPhone, connectToBotFn, appointment, denyRedirect, history, onClose],
  );

  // const resendSms = () => {
  //   if (currentTime === 0) {
  //     sendSms(phone.phone);

  //     setCurrentTime(initialTime);
  //   }
  // };

  const handleCodeType = useCallback((e) => {
    
    setSubmitButtonDisabled(false);

    const inputs = codeWrapper.current.getElementsByTagName('input');

    const id = +e.target.id;

    let code = '';

    Array.from(inputs).forEach((input) => {
      code += input.value;
    });

    setCode(code);

    if (inputs.length > id + 1 && e.target.value) {
      inputs[id + 1].focus();
    }

    // Auto-submit when code is complete (4 digits)
    if (code.length === 4) {
      setTimeout(() => {
        setSubmitButtonDisabled(true);
        setIsAuthLoading(true);
        login({ phone: currentPhone, code }).then((response) => {
          if (response && response.token) {
            if (connectToBotFn) connectToBotFn();
            if (!appointment && !denyRedirect) history.push('/office');
            if (onClose) onClose();
          } else {
            setSubmitButtonDisabled(false);
            setIsAuthLoading(false);
          }
        }).catch(() => {
          setSubmitButtonDisabled(false);
          setIsAuthLoading(false);
        });
      }, 100);
    }
  }, [login, currentPhone, connectToBotFn, appointment, denyRedirect, history, onClose]);

  useEffect(() => {
    const inputs = codeWrapper.current.getElementsByTagName('input');

    inputs[0].focus();

    const handleBackspace = (e) => {
      const inputs = codeWrapper.current.getElementsByTagName('input');
      const id = +e.target.id;

      if (e.keyCode === 8 && !e.target.value && id > 0) {
        let code = '';

        Array.from(inputs).forEach((input) => {
          code += input.value;
        });

        setCode(code);

        inputs[id - 1].focus();
      }
    };

    Array.from(inputs).forEach((input) => {
      input.addEventListener('keydown', handleBackspace);
    });

    return () => {
      Array.from(inputs).forEach((input) => {
        input.removeEventListener('keydown', handleBackspace);
      });
    };
  }, [setCode]);

  // Clear input fields when there's a code error
  useEffect(() => {
    if (error && typeof error === 'object' && error.code) {
      const inputs = codeWrapper.current.getElementsByTagName('input');
      Array.from(inputs).forEach((input) => {
        input.value = '';
      });
      setCode('');
      setSubmitButtonDisabled(false);
      // Focus first input for new attempt
      if (inputs.length > 0) {
        inputs[0].focus();
      }
    }
  }, [error]);

  const handleChangePhone = () => {
    if (onChangePhone) {
      onChangePhone();
    }
  };

  return (
    <>
    <SyncLoadingModal visible={isAuthLoading} />
    <form className="confirmation_of_entry sms">
      <p className="appointment-auth-text">
        Вам {moment.unix(currentSendTime).format('DD.MM.YYYY, HH:mm')} було відправлено на номер{' '}
        <span 
          onClick={handleChangePhone}
          style={{ 
            cursor: 'pointer', 
            color: '#1767c8',
            textDecoration: 'underline'
          }}
          title="Змінити номер телефону"
        >
          +38 {currentPhone}
        </span>
        {' '}повідомлення з кодом. Введіть його в поле нижче:
      </p>

      <div className="auth_code_wrapper">
        <div ref={codeWrapper}>
          {Array.from({ length: 4 }).map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Input handleCodeType={handleCodeType} index={i} key={i} />
          ))}
        </div>
        {error && typeof error === 'object' && error.code && (
          <span className="error_text" style={{ opacity: error.code ? 1 : 0 }}>
            {error.code}
          </span>
        )}
      </div>
      
      {/* <div style={{ display: 'flex', marginBottom: 10, fontSize: 14, color: '#212529', fontWeight: 'bold' }}>
        {currentTime !== 0 ? (
          <span>Ви зможете відправити код заново через {currentTime} секунд</span>
        ) : (
          <span onClick={resendSms} style={{ cursor: 'pointer' }}>
            Відправити СМС заново
          </span>
        )}
      </div> */}
      <Button
        type="submit"
        variant="primary"
        disabled={submitButtonDisabled}
        onClick={onSubmit}
        className="submit-button"
      >
        Підтверджую
      </Button>
    </form>
    </>
  );
};

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = { sendSms, login };

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), withRouter);

export default enhance(Code);
